define('views/modules/calendar/animated-session/exercise/exercise-note',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/form/textarea',
    'views/parts/form/choices',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/exercise-note.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VTextarea,
    VChoices,
    // templates
    TExerciseNote
) {

    var VExerciseNote = Backbone.Epoxy.View.extend({
        template: TExerciseNote,

        regions: {
            pane: ".note-pane",
            input: ".custom-note",
            checkbox: ".tc-note-checkbox",
        },

        initialize: function(options) {
            this.options = _.extend({}, options);
            this.view = {
                input: new VTextarea({
                    label: "calendar:Personalized notes",
                    attribute: 'notes',
                    model: this.model,
                }),
                checkbox: new VChoices({
                    label: "TotalCoaching notes",
                    attribute: 'showTCNotes',
                    model: this.model,
                })
            };
        },

        render: function() {
            var model = this.model,
                isSummary = this.options.summary;
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext({
                    animation: model.getAnimation(),
                    formattedDescription: model.getAnimation().description.replace(/\r?\n/g, "<br />"),
                    notes: model.get('notes'),
                    isSummary: isSummary
                }, 'exercises')));

            this.applyBindings();
            this.generateZones();
            if (!isSummary) {
                this.assign(this.view.input, this.zone.$input)
                    .assign(this.view.checkbox, this.zone.$checkbox);
            }
            return this;
        },

        toggle: function() {
            this.$el.slideToggle(125);
        },

    });

    return VExerciseNote;

});

